import { createBrowserHistory } from 'history';

/**
Export the Browser history to use with React Router to make routes between components.
*/
export default createBrowserHistory();
